const state = {
    crumbs: [],
};

const getters = {
    crumbs: state => state.crumbs,
}

const actions = {};

const mutations = {
    setCrumbs(state, crumbs) {
        state.crumbs = crumbs;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};
